import dayjs from '../../dayjs';
import { DateTimeTypeAryType, DateTimeFormatInfoType, DateType } from "../types"

/**
 * @description: 
 * @param {DateType} value
 * @return {*}
 */
export function getDateShowFormat(value: DateType) {
  let v = value
  if (typeof value === 'string') {
    const customFormat = getWindowDateShowFormat()
    const customFormatAry = [customFormat, `${customFormat} HH:mm`, `${customFormat} HH:mm:ss`]
    const v1 = dayjs(value)
    const v2 = dayjs(value, customFormatAry)
    v = v1.isValid() ? value : v2.format('YYYY-MM-DD HH:mm:ss')
  }
  return v
}

/**
 * @description: 获取window.ECODE对象中的日期格式
 * @return {*}
 */
export function getWindowDateShowFormat() {
  let showFormat = ''
  if (window.ECODE && window.ECODE.locale) {
    showFormat = window.ECODE.locale.dateformat || window.ECODE.locale.tdate_format
  }
  return showFormat
}

/**
 * @description: 获取window.ECODE对象中的日期时间格式
 * @return {*}
 */
export function getWindowDateTimeShowFormat() {
  let showFormat = ''
  if (window.ECODE && window.ECODE.locale) {
    showFormat = window.ECODE.locale.datetimeformat || window.ECODE.locale.tdatetime_format
  }
  return showFormat
}
/**
 * @description: 根据日期时间格式获取相对应的信息
 * @param {string} date
 * @return {*}
 */
export function getDateTimeFormat(date: string) {
  const regDate = /[Y|y|M|D|d]/  // 匹配日期
  const regTime = /[H|h|m|S|s]/  // 匹配时间
  let arr = date?.split('')
  //获取日期开始index
  const dateStartIndex = arr?.findIndex(item => regDate.test(item))
  //获取时间开始index
  const timeStartIndex = arr?.findIndex(item => regTime.test(item))
  arr = arr?.reverse()
  //获取日期结束index
  const dateEndIndex = arr?.length - arr?.findIndex(item => regDate.test(item))
  //获取时间结束index
  const timeSndIndex = arr?.length - arr?.findIndex(item => regTime.test(item))
  //获取日期格式
  const dateFormat = date?.slice(dateStartIndex, dateEndIndex)
  //获取时间格式
  const timeFormat = date?.slice(timeStartIndex, timeSndIndex)

  //------日期信息------
  const dateFormatAry = dateFormat.split('')
  //年月日的顺序数组
  const date_sortAry: DateTimeTypeAryType[] = []
  //日期分隔符的数组(以第一个分隔符号为准)
  const date_separatorAry: string[] = []
  //日期处理
  let [Y, M, D] = ['', '', '']
  dateFormatAry.forEach((ele: any) => {
    if (regDate.test(ele)) {
      if (date_sortAry.indexOf(ele) === -1) {
        date_sortAry.push(ele)
      }
      if (/[Y/y]/.test(ele)) {
        Y += ele
      } else if (/[M]/.test(ele)) {
        M += ele
      } else {
        D += ele
      }
    } else {
      date_separatorAry.push(ele)
    }
  })

  //------时间信息------
  const timeFormatAry = timeFormat.split('')
  //时分秒的顺序数组
  const time_sortAry: string[] = []
  //时间分隔符的数组(以第一个分隔符号为准)
  const time_separatorAry: string[] = []
  //时间处理
  let [H, m, s] = ['', '', '']
  timeFormatAry.forEach(ele => {
    if (regTime.test(ele)) {
      if (time_sortAry.indexOf(ele) === -1) {
        time_sortAry.push(ele)
      }
      if (/[H/h]/.test(ele)) {
        H += ele
      } else if (/[m]/.test(ele)) {
        m += ele
      } else {
        s += ele
      }
    } else {
      time_separatorAry.push(ele)
    }
  })
  const dateTimeFormatInfo: DateTimeFormatInfoType = {
    dateFormat,
    timeFormat,
    Y,
    M,
    D,
    date_sortAry,
    date_separatorAry,
    H,
    m,
    s,
    time_sortAry,
    time_separatorAry
  }
  return dateTimeFormatInfo
}

/**
 * @description: 根据传入的或者窗口中的标准格式，根据传入的typeAry获取格式转化信息
 * @param {DateTimeTypeAryType[]} typeAry
 * @param {string} format
 * @return {*}
 */
export function getCustomFormatByWindow(typeAry: DateTimeTypeAryType[], format?: string) {
  const windowFormat = getWindowDateTimeShowFormat()
  //获取最终的标准日期格式
  let f: string = ''
  if (format) {
    f = format
  } else if (windowFormat) {
    f = windowFormat
  } else {
    f = 'YYYY-MM-DD HH:mm:ss'
  }
  const formatInfo: DateTimeFormatInfoType = getDateTimeFormat(f)
  const { dateFormat, date_sortAry, date_separatorAry } = formatInfo
  const dateAry: DateTimeTypeAryType[] = typeAry?.filter(item => /[Y|y|M|D|d]/.test(item))
  //日期格式处理
  let d: string = ''
  const newDateAry: DateTimeTypeAryType[] = date_sortAry.filter((item: DateTimeTypeAryType) => dateAry.indexOf(item) !== -1)
  const date_separator = date_separatorAry[0] || ''
  if (newDateAry.length === 3) {
    d = dateFormat
  } else if (newDateAry.length === 2) {
    d = formatInfo[newDateAry[0]] + date_separator + formatInfo[newDateAry[1]]
  } else if (newDateAry.length === 1) {
    d = formatInfo[newDateAry[0]]
  } else {
    d = ''
  }
  //时间格式处理
  let t: string = ''
  const H = typeAry.indexOf('H') !== -1
  const m = typeAry.indexOf('m') !== -1
  const s = typeAry.indexOf('s') !== -1
  if (H && m && s) {
    t = 'HH:mm:ss'
  } else if (H && m) {
    t = 'HH:mm'
  } else if (H) {
    t = 'HH'
  } else {
    t = ''
  }
  //输出格式处理
  let filterFormat = ''
  if (d && t) {
    filterFormat = d + ' ' + t
  } else if (d) {
    filterFormat = d
  } else if (t) {
    filterFormat = t
  }
  return {
    format,
    filterFormat,
    formatInfo
  }
}

/**
 * @description: 根据传入的或者窗口中的标准格式，根据传入的typeAry获取格式转化信息，同时包含对日期的转化
 * @param {DateType} date
 * @param {DateTimeTypeAryType[]} typeAry
 * @param {string} format
 * @return {*}
 */
export function getCustomFormatDateByWindow(date: any, typeAry: DateTimeTypeAryType[], format?: string) {
  const f = getCustomFormatByWindow(typeAry, format)
  return dayjs(date).format(f.filterFormat)
}